import { z } from "zod";

const emailFormat = z.string().email();

export const ALTERNATE_EMAIL_MAX_LENGTH = 255;

/**
 * Trims a raw alternate-email input into what gets sent on the wire.
 * Blank/whitespace-only becomes `null` — sending `null` explicitly is what
 * clears a previously-stored alternate email server-side; omitting the key
 * entirely leaves it untouched, so callers must always include this result.
 */
export const normalizeAlternateEmail = (value) => {
  const trimmed = (value ?? "").trim();
  return trimmed === "" ? null : trimmed;
};

/**
 * Validates an alternate email against the same rules the server enforces:
 * optional, RFC format, 255 char max, and must differ from the primary email
 * case-insensitively. Returns an error message string, or `null` when valid
 * (including when the field is blank — it is never required).
 */
export const validateAlternateEmail = ({ alternateEmail, primaryEmail }) => {
  const alternate = normalizeAlternateEmail(alternateEmail);
  if (!alternate) return null;

  if (alternate.length > ALTERNATE_EMAIL_MAX_LENGTH) {
    return `Alternate email must be ${ALTERNATE_EMAIL_MAX_LENGTH} characters or fewer`;
  }

  if (!emailFormat.safeParse(alternate).success) {
    return "Enter a valid email";
  }

  const primary = normalizeAlternateEmail(primaryEmail);
  if (primary && primary.toLowerCase() === alternate.toLowerCase()) {
    return "The alternate email must be different from the primary email.";
  }

  return null;
};
